import * as apiService from './api';
import * as cacheService from './cache';
import * as logService from './log';

export {
  apiService,
  cacheService,
  logService
};


// WEBPACK FOOTER //
// ./src/shared/services/index.ts